import { render } from "./Loader.vue?vue&type=template&id=74d43e0d&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=74d43e0d&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cts-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d43e0d"]])

export default __exports__